'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/react-autowhatever/dist/index.js
// module id = 613
// module chunks = 0